import React, { useState , useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass, faTimes } from "@fortawesome/free-solid-svg-icons";
import { stockSearch } from "../api/user";
import { useNavigate } from "react-router-dom";


const SearchBar = ({ newsearch, newhandleChange, newonSubmit , newsetCategory }) => {
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 768);
  const [category, setCategory] = useState("Stocks");
  const [search, setSearch] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const abortControllerRef = useRef(null);
  const submittedRef = useRef(false);
  const navigate = useNavigate();



const lastQueryRef = useRef("");

const handleChange = async (e) => {
  const value = e.target.value;
  const trimmed = value.trim();

  newhandleChange(value);
  setSearch(value);
  lastQueryRef.current = trimmed;
  submittedRef.current = false;

  if (trimmed.length === 0) {
    setSuggestions([]);
    return;
  }

  // Abort previous request
  if (abortControllerRef.current) {
    abortControllerRef.current.abort();
  }

  const controller = new AbortController();
  abortControllerRef.current = controller;

  setLoading(true);

  try {
    const data = { category, query: trimmed };
    const response = await stockSearch(data, controller.signal);

    if (lastQueryRef.current === trimmed && !submittedRef.current) {
      setSuggestions(response?.data || []);
    }
  } catch (error) {
    if (error.name !== "CanceledError") {
      console.error("Live search failed:", error);
    }
    setSuggestions([]);
  } finally {
    setLoading(false);
  }
};




  // const handleSelectSuggestion = (ticker) => {
  //   setSearch(ticker);
  //   newhandleChange(ticker);
  //   setSuggestions([]); // Close dropdown
  // };

const handleSubmit = async (e) => {
  e.preventDefault();

  const trimmed = search.trim();
  if (!trimmed) {
    alert("Please enter a search term.");
    return;
  }

  // Abort any in-flight request
  if (abortControllerRef.current) {
    abortControllerRef.current.abort();
  }

  submittedRef.current = true;
  setSuggestions([]); // Immediately clear dropdown
  newonSubmit(e);
};



//   const handleSelectSuggestion = (ticker) => {
//     // alert('tar');
//     localStorage.setItem("selectedTicker", ticker);
//   const trimmed = ticker.trim();
//   if (!trimmed) {
//     alert("Please enter a search term.");
//     return;
//   }

// const cleaned = trimmed.replace(/^[CX]:/, '');

//   setSearch(cleaned);
//   newhandleChange(trimmed);
//   setSuggestions([]);

//   // ✅ Trigger submit manually
//   newonSubmit({ type: "manual", from: "suggestion" });
//   };


const handleSelectSuggestion = (ticker) => {
    // ✅ Save to localStorage
  localStorage.setItem("selectedTicker", ticker);
  const trimmed = ticker.trim();

  if (!trimmed) {
    alert("Please enter a search term.");
    return;
  }

  const cleaned = trimmed.replace(/^[CX]:/, "");

  setSearch(cleaned);
  newhandleChange(trimmed);
  setSuggestions([]);

  // ✅ If current path is /search, navigate directly
  if (window.location.pathname === "/search") {
    navigate(`/chartSearch/${cleaned}`);
    localStorage.removeItem("selectedTicker"); // reset after use
    return; // stop here, don’t trigger submit
  }

  // ✅ Otherwise, trigger submit manually
  newonSubmit({ type: "manual", from: "suggestion" });
};


const getPrefix = () => {
  if (category === "Forex") return "C:";
  if (category === "Crypto") return "X:";
  return "";
};


  return (

    <form
      onSubmit={handleSubmit}
      className="max-md:w-full flex gap-2 items-center "
    >
      {/* Dropdown */}
      <select
        value={category}
        onChange={(e) => {
            setCategory(e.target.value);
            newsetCategory(e.target.value);
            setSearch('');
          }}
          style={{backgroundSize: "28px"}}
        className={`border rounded-full text-sm p-2 bg-slate-50 focus:outline-none focus:border-green-300 appearance-none pr-7 bg-[url(data:image/svg+xml,%3Csvg%20width%3D%2212%22%20height%3D%229%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2020%2020%22%20fill%3D%22currentColor%22%20aria-hidden%3D%22true%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20d%3D%22M5.23%207.21a.75.75%200%20011.06.02L10%2011.585l3.71-4.355a.75.75%200%20011.14.976l-4.25%205a.75.75%200%2001-1.14%200l-4.25-5a.75.75%200%2001.02-1.06z%22%20clip-rule%3D%22evenodd%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E)] bg-no-repeat bg-right`}
      >
        <option value="Stocks">Stocks</option>
        <option value="Forex">Forex</option>
        <option value="Crypto">Crypto</option>
      </select>

<div className="relative w-full md:w-[230px]">
  {getPrefix() && (
    <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 text-sm">
      {getPrefix()}
    </span>
  )}

  <input
    type="text"
    placeholder="Search..."
    value={search}
    onChange={handleChange}
    className={`border rounded-full text-sm w-full p-3 py-2 focus:outline-none focus:border-green-300 bg-slate-50 ${
      getPrefix() ? "pl-7" : "pl-3"
    }`}
  />

  <button type="submit" style={{ display: "none" }}></button>

  <FontAwesomeIcon
    onClick={handleSubmit}
    className="absolute right-3 top-3 text-slate-500 cursor-pointer"
    icon={faMagnifyingGlass}
  />


        {/* Suggestions Dropdown */}
        {(loading || suggestions.length > 0) && (
          <ul className="absolute top-full left-0 w-full bg-white border border-gray-200  max-h-52 overflow-y-auto rounded-md shadow-md z-10">
            {loading ? (
              <li className="p-2 text-sm text-gray-500 italic text-center">
                Searching...
              </li>
            ) : (
              suggestions.map((item, index) => (
                <li
                  key={index}
                  className="p-2 text-sm hover:bg-gray-100 cursor-pointer text-gray-500"
                  onClick={() => handleSelectSuggestion(item.ticker)}
                >
                  {item.short_name}    ({item.name})
                </li>
              ))
            )}
          </ul>
        )}
      </div>
    </form>

  );
};

export default SearchBar;
